import { Dialog } from '../dialog/index.js';
import { isMobile } from '../../../../Assets/configuration/index.js';
import './index.scss';

export default class EcoLabel extends HTMLElement {
  constructor() {
    super();

    const url = this.getAttribute('url');
    const type = this.getAttribute('type');
    const linkLearnMore = 'https://www.fnac.com/indice-de-reparabilite';
    const dialogType = this.getAttribute('dialogType');

    const dialogTitles = {
      sustainabilityIndex: 'Indice de durabilité',
      repairIndex: 'Indice de réparabilité',
      energyLabel: 'Classe énergétique'
    };

    this.addEventListener('click', () => {
      this._dialog = new Dialog({
        title: `${dialogTitles[dialogType]}`,
        type: `${isMobile ? 'bottomSheet' : ''}`,
        content: `
          <div class="f-dialogEcoLabel__content" data-automation-id="panel-${dialogType}">
            ${
              type === 'image'
                ? `<img class="f-dialogEcoLabel__image" src="${url}" alt="${dialogTitles[dialogType]}" />`
                : `<iframe class="f-dialogEcoLabel__iframe" src="${url}"></iframe>`
            }

            ${['greenIndex', 'repairIndex'].includes(dialogType) ? `<a href="${linkLearnMore}" class="f-button f-button--black">En savoir plus</a>` : ''}
          </div>
          `,
        overlay: true
      });
    });
  }
}

customElements.get('f-eco-label') || customElements.define('f-eco-label', EcoLabel);
